<template>
  <div class="barra-superior">
    <div class="barra-superior-slot barra-superior-slot--start">
      <button
        v-if="device.isMobile"
        type="button"
        class="barra-superior-menu-trigger"
        :aria-label="$t('menuSuperior.openMenu')"
        @click="$emit('open-site-menu')"
      >
        <i class="pi pi-bars" aria-hidden="true" />
      </button>
      <div
        v-if="device.isMobile"
        class="barra-superior-logo barra-superior-logo--mobile"
        @click="goTo('/')"
      >
        <logo-componente :device="device"></logo-componente>
      </div>
    </div>
    <div v-if="!device.isMobile" class="barra-superior-slot barra-superior-slot--center">
      <div class="barra-superior-logo" @click="goTo('/')">
        <logo-componente :device="device"></logo-componente>
      </div>
    </div>
    <div class="barra-superior-slot barra-superior-slot--end">
    <button
      type="button"
      class="barra-superior-icon-btn barra-superior-icon-btn--theme"
      :title="$t('appearance.toggleTitle')"
      :aria-label="$t('appearance.toggleAria')"
      @click="toggleAppearance"
    >
      <i :class="appearanceTheme === 'light' ? 'pi pi-moon' : 'pi pi-sun'" aria-hidden="true" />
    </button>
    <locale-switcher class="barra-superior-locale" />
    <!--div class="barra-superior-menu md-6" v-if="!device.isMobile">
      <BuscarProducto :device="device"/>
    </div-->
    <div class="barra-superior-iconos">
      <a
        v-if="snatPortalUrl && authenticated"
        :href="snatPortalUrl"
        class="barra-superior-icon-btn barra-superior-icon-btn--link"
        target="_blank"
        rel="noopener noreferrer"
        :title="$t('menuSuperior.snatPortalTitle')"
        :aria-label="$t('menuSuperior.snatPortalAria')"
      >
        <i class="pi pi-external-link" aria-hidden="true" />
      </a>
      <button
        v-if="snatClientAccess && nativeSnatToolsEnabled"
        type="button"
        class="barra-superior-icon-btn barra-superior-icon-btn--snat-tools"
        :title="$t('menuSuperior.snatToolsTitle')"
        :aria-label="$t('menuSuperior.snatToolsAria')"
        @click="openSnatUnifiedToolsBar"
      >
        <i class="pi pi-book" aria-hidden="true" />
        <span v-if="snatToolsBadgeTotal" class="barra-superior-snat-badge" aria-hidden="true">{{
          snatToolsBadgeTotal > 99 ? '99+' : snatToolsBadgeTotal
        }}</span>
      </button>
      <button
        type="button"
        class="barra-superior-icon-btn"
        :aria-label="$t('menuSuperior.cartAria')"
        @click="goTo('/validar-carrito')"
      >
        <i class="pi pi-shopping-cart" aria-hidden="true" />
      </button>

      <button
        v-if="authenticated"
        type="button"
        class="barra-superior-icon-btn barra-superior-icon-btn--session barra-superior-icon-btn--session-on"
        :title="$t('menuSuperior.profileTitle')"
        :aria-label="$t('menuSuperior.profileAria')"
        @click="goTo('/perfil-usuario')"
      >
        <i class="pi pi-user" aria-hidden="true" />
      </button>
      <button
        v-else
        type="button"
        class="barra-superior-icon-btn barra-superior-icon-btn--session"
        :title="$t('menuSuperior.loginTitle')"
        :aria-label="$t('menuSuperior.loginAria')"
        @click="goTo('/login')"
      >
        <i class="pi pi-sign-in" aria-hidden="true" />
      </button>
    </div>
    </div>

    <!--div style="position:absolute; left:0; top: 5rem; right: 0; background-color: white" class="barra-buscar-mobile" v-if="device.isMobile">
      <BuscarProducto  :device="device"/>
      <br />
    </div-->
  </div>
</template>

<script>
import LogoComponente from '@/components/LogoComponent';
import LocaleSwitcher from '@/components/LocaleSwitcher.vue';
//import MenuItem from 'primevue/api';
//import SideBar from 'primevue/sidebar';
import { mapGetters } from 'vuex';
import { sessionStore } from '@/store/session';
import { useAppearanceStore } from '@/store/appearance';
import { getSnatClientPortalUrl } from '@/utils/snatTicketPayloadExtras';
import { openSnatUnifiedTools } from '@/utils/snatUnifiedToolsBus';
import { reqNotebookItems } from '@/utils/requirementsNotebook';

export default {
  emits: ['open-site-menu'],
  props: {
    device: { type: Object, required: true },
    snatClientAccess: {
      type: Boolean,
      default: false,
    },
    /** Cuadernos / ticket embebidos (vs hub centralizado por env). */
    nativeSnatToolsEnabled: {
      type: Boolean,
      default: true,
    },
  },
  name: 'MenuSuperior',
  components: { LogoComponente, LocaleSwitcher },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this._kosexaAppear) window.removeEventListener('kosexa-appearance-changed', this._kosexaAppear);
  },
  computed: {
    appearanceTheme() {
      void this.appearanceRevision;
      return useAppearanceStore().theme;
    },
    snatPortalUrl() {
      return getSnatClientPortalUrl();
    },
    getVisibilidadSidebar() {
      return this.carritoVisible;
    },
    authenticated() {
      void this.sessionRevision;
      const s = sessionStore();
      return !!(s.access_token || (typeof localStorage !== 'undefined' && localStorage.getItem('access_token')));
    },
    ...mapGetters({
      visibility: "carrito/getVisibilidad",
    }),
    ...mapGetters('errorNotebook', {
      snatErrorNotebookCount: 'count',
    }),
    snatReqNotebookCount() {
      return reqNotebookItems.value?.length ?? 0;
    },
    snatToolsBadgeTotal() {
      return (this.snatErrorNotebookCount || 0) + (this.snatReqNotebookCount || 0);
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this._kosexaAppear = () => {
      this.appearanceRevision += 1;
    };
    window.addEventListener('kosexa-appearance-changed', this._kosexaAppear);
  },
  methods: {
    openSnatUnifiedToolsBar() {
      openSnatUnifiedTools('errors');
    },
    handleScroll() {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      if (currentScrollPosition < this.lastScrollPosition) {
        // Si el usuario está escrolleando hacia arriba
        this.isMenuVisible = true;
      } else {
        // Si el usuario está escrolleando hacia abajo
        this.isMenuVisible = false;
      }
      this.lastScrollPosition = currentScrollPosition;
    },
    goTo(route){
      this.$router.push(route);
    },
    toggleAppearance() {
      useAppearanceStore().toggleTheme();
    },
    ocultarCarrito(){
      this.visibilidad_menu = false;
    },
    abrirCarrito() {
      this.visibilidad_menu = true;
    },
  },
  data() {
    return {
      lastScrollPosition: 0,
      isMenuVisible: true,
      visibilidad_menu: false,
      menuItems: [
        {
          label: 'Inicio',
          icon: 'pi pi-home',
          to: '/'
        },
        {
          label: 'Catálogo',
          icon: 'pi pi-shopping-cart',
          to: '/catalogo'
        },
        {
          label: 'Contacto',
          icon: 'pi pi-envelope',
          to: '/contacto'
        },
        {
          label: 'Trabaja con nosotros',
          icon: 'pi pi-briefcase',
          to: '/trabaja-con-nosotros'
        }
      ],
      /** Dependencia reactiva para refrescar `authenticated` tras login/logout u otra pestaña. */
      sessionRevision: 0,
      /** Re-render del ícono tema (Pinia + Options API). */
      appearanceRevision: 0,
    };
  }
};
</script>

<style>
/* Importar el CSS global y específico para consistencia en multi-tienda (Vue + Django backend) */
@import '~@/assets/css/main.css';
@import '~@/assets/css/menu-superior.css';
</style>